export function serialize(obj, prefix) {
  let str = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p];
      str.push(v !== null && typeof v === 'object' ? serialize(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }
  }
  return str.join('&');
}

export function waitForGlobalVariable(variableName) {
  return new Promise((resolve) => {
    // Сразу проверяем, существует ли переменная
    if (window[variableName]) {
      resolve(window[variableName]); // Если да, сразу разрешаем Promise
    } else {
      // Если переменной нет, начинаем наблюдение
      const checkVariable = setInterval(() => {
        if (window[variableName]) {
          clearInterval(checkVariable); // Останавливаем интервал
          resolve(window[variableName]); // Разрешаем Promise
        }
      }, 100); // Проверяем каждые 100 мс
    }
  });
}
